import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';

export const BiginPipelineChart = ({ deals, getStageColor }) => (
    <>
      {deals.length > 0 && (
        <Card className="bg-white border shadow-sm">
          <CardHeader>
            <CardTitle className="text-lg">Pipeline Overview</CardTitle>
            <CardDescription>Deals by stage</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-3">
              {Object.entries(
                deals.reduce((acc, deal) => {
                  const stage = deal.Stage || 'Unassigned';
                  acc[stage] = (acc[stage] || 0) + 1;
                  return acc;
                }, {})
              ).map(([stage, count]) => (
                <div 
                  key={stage} 
                  className={`px-4 py-2 rounded-lg border ${getStageColor(stage)} flex items-center gap-2`}
                >
                  <span className="font-medium">{stage}</span>
                  <Badge variant="secondary" className="bg-white/50">{count}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </>
);
